import React from 'react';

interface SelectAllBlockProps {
  isChecked: boolean;
  onDeleteAll: () => void;
  onDeselect: () => void;
}

const SelectAllBlock = (props: SelectAllBlockProps) => {
  return (
    <div className="panel-block panel-block-light">
      <div className="clearfix">
        <div className="form-check form-check-inline align-middle mr-2">
          <input
            onChange={props.onDeselect}
            type="checkbox"
            checked={props.isChecked}
            className="mr-3"
            aria-label="Select All Parameters"
          />
          <span className="cursor-pointer form-check-label">Select All</span>
        </div>
        <button
          onClick={props.onDeleteAll}
          className="btn btn-link-dark p-0"
          title="Delete Parameters"
          data-parameters="deleteSelected"
        >
          <span className="icon-bzm-delete icon-xs" aria-hidden="true"></span>
          <span className="sr-only">Delete</span>
        </button>
      </div>
    </div>
  );
};

export default SelectAllBlock;
